












import Vue from 'vue'
export default Vue.extend({
  methods: {
    closeLoading: function() {
      this.$bus.$emit('show-loading', false);
    }
  }
})
